interface Comment {
  avatar: string;
  name: string;
  time: string;
  content: string;
  likes: string;
}

const comments: Comment[] = [
  {
    avatar: "https://readdy.ai/api/search-image?query=Stylized%20abstract%20user%20avatar%20with%20warm%20coral%20gradient%20tones%2C%20minimalist%20circular%20design%2C%20geometric%20pattern%2C%20modern%20social%20media%20profile%20picture%20style&width=100&height=100&seq=avatar-01-91cg&orientation=squarish",
    name: '吃瓜群众小王',
    time: '3分钟前',
    content: '这个平台太棒了！每天都能看到最新鲜的吃瓜内容，视频画质高清，播放流畅不卡顿，简直是我的快乐源泉。',
    likes: '1.2万',
  },
  {
    avatar: "https://readdy.ai/api/search-image?query=Stylized%20abstract%20user%20avatar%20with%20warm%20amber%20gradient%20tones%2C%20minimalist%20circular%20design%2C%20geometric%20pattern%2C%20modern%20social%20media%20profile%20picture%20style&width=100&height=100&seq=avatar-02-91cg&orientation=squarish",
    name: '娱乐圈观察员',
    time: '15分钟前',
    content: '91吃瓜更新速度真的快，热点事件刚出来这边视频就上线了。高清画质看着就是舒服，推荐给所有爱八卦的朋友。',
    likes: '8.6千',
  },
  {
    avatar: "https://readdy.ai/api/search-image?query=Stylized%20abstract%20user%20avatar%20with%20warm%20rose%20gradient%20tones%2C%20minimalist%20circular%20design%2C%20geometric%20pattern%2C%20modern%20social%20media%20profile%20picture%20style&width=100&height=100&seq=avatar-03-91cg&orientation=squarish",
    name: '深夜吃瓜人',
    time: '28分钟前',
    content: '每晚睡前必刷91吃瓜，资源太全了！从娱乐八卦到社会热点应有尽有，手机端体验也很流畅。',
    likes: '6.3千',
  },
  {
    avatar: "https://readdy.ai/api/search-image?query=Stylized%20abstract%20user%20avatar%20with%20warm%20terracotta%20gradient%20tones%2C%20minimalist%20circular%20design%2C%20geometric%20pattern%2C%20modern%20social%20media%20profile%20picture%20style&width=100&height=100&seq=avatar-04-91cg&orientation=squarish",
    name: '热点追踪者',
    time: '42分钟前',
    content: '关注91吃瓜快半年了，内容质量一直很高。视频更新频率快、种类丰富，是我每天获取娱乐资讯的首选平台。',
    likes: '5.1千',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="w-full py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 text-center mb-2">网友热评</h2>
        <p className="text-foreground-500 text-sm text-center mb-10">真实用户评价，看看大家怎么说</p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {comments.map((comment) => (
            <div key={comment.name} className="bg-background-50 rounded-xl p-5">
              <div className="flex items-center gap-3 mb-3">
                <img
                  src={comment.avatar}
                  alt={comment.name}
                  className="w-10 h-10 rounded-full object-cover flex-shrink-0"
                />
                <div className="min-w-0">
                  <p className="text-sm font-medium text-foreground-800 truncate">{comment.name}</p>
                  <p className="text-xs text-foreground-400">{comment.time}</p>
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed mb-3">{comment.content}</p>
              <div className="flex items-center gap-1 text-xs text-foreground-400">
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-thumb-up-line"></i>
                </div>
                <span>{comment.likes}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}